export default "__VITE_ASSET__396ab499__"